var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationPhoto = function SvgGeneralInformationPhoto(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "M19.143 21.476H4.858a2.333 2.333 0 0 1-2.334-2.333V4.857a2.333 2.333 0 0 1 2.334-2.333h14.285a2.333 2.333 0 0 1 2.334 2.333v14.286a2.333 2.333 0 0 1-2.334 2.333Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M9.07 7.902a1.167 1.167 0 1 1-2.335 0 1.167 1.167 0 0 1 2.334 0",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#666",
    d: "m21.477 14.967-3.802-3.8a1.327 1.327 0 0 0-1.874 0l-5.222 5.221-2.38-2.378a1.327 1.327 0 0 0-1.875 0l-3.8 3.8"
  })));
};
export default SvgGeneralInformationPhoto;